import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Save } from "lucide-react";

export const CampaignSettings = ({ onSaved }) => {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/admin/email-campaigns/settings").then((r) => setC(r.data)).catch(() => {}); }, []);
  if (!c) return null;
  const set = (k) => (e) => setC({ ...c, [k]: e.target.value });
  const save = async () => {
    try {
      const r = await api.put("/admin/email-campaigns/settings", { daily_limit: Number(c.daily_limit), batch_size: Number(c.batch_size), copy_email: c.copy_email, test_email: c.test_email });
      setC(r.data); toast.success("Réglages enregistrés"); onSaved?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Enregistrement impossible"); }
  };
  return (
    <div className="max-w-xl space-y-3" data-testid="campaign-settings">
      <div className="grid gap-3 sm:grid-cols-2">
        <div><Label className="text-xs">Quota par jour</Label><Input type="number" value={c.daily_limit} onChange={set("daily_limit")} data-testid="cfg-daily-limit" /></div>
        <div><Label className="text-xs">E-mails par envoi (toutes les 15 min)</Label><Input type="number" value={c.batch_size} onChange={set("batch_size")} data-testid="cfg-batch-size" /></div>
      </div>
      <div><Label className="text-xs">Adresse qui reçoit une copie (1 par jour)</Label><Input type="email" value={c.copy_email} onChange={set("copy_email")} placeholder="copie@bougieducoeur.com" data-testid="cfg-copy-email" /></div>
      <div><Label className="text-xs">Adresse de test</Label><Input type="email" value={c.test_email} onChange={set("test_email")} placeholder="vous@exemple.fr" data-testid="cfg-test-email" /></div>
      <p className="text-xs text-muted-foreground">Expéditeur : mail@bougieducoeur.com via Amen (smtp.securemail.pro, SSL 465). Amen compte chaque destinataire — tests et copie inclus — dans le quota du jour : 5 000/jour avec l’offre Email Professional, 500 avec l’offre Personal.</p>
      <Button className="rounded-full bg-fuchsia-500 hover:bg-fuchsia-400" onClick={save} data-testid="cfg-save"><Save size={14} className="mr-1.5" /> Enregistrer</Button>
    </div>
  );
};
